<ion-card>
  <ion-card-header>
    <ion-card-title>Iktatás a Sulinformból</ion-card-title>
    <ion-card-subtitle>
      Ami az iskolai rendszerben már keletkezett – beadott kérvény, határozat,
      bizonyítvány – azt nem kell újra begépelni. Jelöld ki, mi kerüljön a könyvbe:
      a rendszer érkezteti, iktatja, és a meglévő PDF-et csatolja hozzá.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <!-- Forrásválasztó csempék -->
    <div class="ikt-szamok">
      <div class="ikt-szam" *ngFor="let f of forrasok"
           [class.figyelem]="f.kulcs === aktivForras" (click)="forrasValt(f.kulcs)">
        <div class="ertek">{{ f.varakozo < 0 ? '–' : f.varakozo }}</div>
        <div class="cimke">{{ f.nev }}</div>
        <div class="cimke" style="opacity:.75">{{ f.irany === 'be' ? 'bejövő' : 'kimenő' }}</div>
      </div>
    </div>

    <ion-note color="medium" *ngIf="aktiv" style="display:block;margin:-4px 0 12px;font-size:.82rem">
      {{ aktiv.leiras }}
    </ion-note>

    <!-- Iktatási beállítások: ezek MINDEN kijelölt tételre érvényesek -->
    <div class="ikt-fejsor">
      <ion-select label="Iktatókönyv" label-placement="stacked" interface="popover"
                  [(ngModel)]="beallitas.konyv">
        <ion-select-option *ngFor="let k of konyvek" [value]="k.id">
          {{ k.jel }} – {{ k.nev }} ({{ k.ev }})
        </ion-select-option>
      </ion-select>
      <ion-select class="hosszu-ertek" label="Irattári tétel" label-placement="stacked" interface="popover"
                  [interfaceOptions]="{ cssClass: 'hosszu-opciok' }" [(ngModel)]="beallitas.tetelszam">
        <ion-select-option value="">– nincs –</ion-select-option>
        <ion-select-option *ngFor="let t of terv" [value]="t.tetelszam">
          {{ t.tetelszam }} – {{ t.megnevezes }}
        </ion-select-option>
      </ion-select>
      <ion-select label="Ügyintéző" label-placement="stacked" interface="popover"
                  [(ngModel)]="beallitas.ugyintezo">
        <ion-select-option value="">– nincs szignálva –</ion-select-option>
        <ion-select-option *ngFor="let u of ugyintezok" [value]="u.azonosito">{{ u.nev }}</ion-select-option>
      </ion-select>
      <ion-select label="Irány" label-placement="stacked" interface="popover" [(ngModel)]="beallitas.irany">
        <ion-select-option value="be">bejövő</ion-select-option>
        <ion-select-option value="ki">kimenő</ion-select-option>
      </ion-select>
    </div>

    <div class="ikt-fejsor">
      <ion-searchbar placeholder="Szűrés névre, tárgyra, dátumra…" [(ngModel)]="szoveg"
                     [debounce]="200"></ion-searchbar>
      <ion-checkbox labelPlacement="end" [checked]="csakIktatatlan"
                    (ionChange)="csakIktatatlan = $event.detail.checked; forrasValt(aktivForras)">
        Csak a még nem iktatottak
      </ion-checkbox>
      <ion-button size="small" fill="outline" (click)="mindet(true)">Mindet kijelöl</ion-button>
      <ion-button size="small" fill="clear" (click)="mindet(false)">Kijelölés törlése</ion-button>
      <ion-button size="small" (click)="iktat()" [disabled]="folyamatban || !kijelolt.size">
        <ion-icon slot="start" name="create-outline"></ion-icon>
        {{ folyamatban ? 'Iktatás…' : ('Iktatás (' + kijelolt.size + ')') }}
      </ion-button>
    </div>

    <div *ngIf="!konyvek.length" class="ikt-ures">
      Előbb nyiss egy iktatókönyvet a <b>Beállítások → Iktatókönyvek</b> menüben.
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th style="width:36px"></th>
            <th>Dátum</th><th>Érintett</th><th>Megnevezés</th><th>Fájl</th><th>Állapot</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of szurtTetelek" [class.ervenytelen]="t.mar_iktatva">
            <td>
              <ion-checkbox [checked]="kivan(t)" [disabled]="t.mar_iktatva"
                            (ionChange)="valt(t, $event.detail.checked)"></ion-checkbox>
            </td>
            <td class="szam">{{ t.datum }}</td>
            <td>{{ t.szemely }}</td>
            <td>{{ t.cim }}</td>
            <td>
              <ion-icon *ngIf="t.path" name="document-attach-outline" color="medium"
                        title="Van hozzá PDF"></ion-icon>
            </td>
            <td>
              <ion-badge color="success" *ngIf="t.mar_iktatva">{{ t.iktatoszam }}</ion-badge>
              <ion-badge color="medium" *ngIf="!t.mar_iktatva">iktatásra vár</ion-badge>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!szurtTetelek.length">
        Ebben a forrásban nincs iktatásra váró tétel.
      </div>
    </div>

    <!-- Eredmény -->
    <div *ngIf="eredmeny" style="margin-top:16px">
      <h3 style="font-size:.95rem;margin:0 0 8px">Iktatás eredménye</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <tbody>
            <tr *ngFor="let s of eredmeny.siker">
              <td><ion-badge color="success">{{ s.iktatoszam }}</ion-badge></td>
              <td>{{ s.cim }}</td>
              <td><ion-button size="small" fill="clear" (click)="ugyiratra(s)">Ügyirat</ion-button></td>
            </tr>
            <tr *ngFor="let h of eredmeny.hibak">
              <td><ion-badge color="warning">kimaradt</ion-badge></td>
              <td>{{ h.cim || h.azonosito }}</td>
              <td>{{ h.hiba }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ion-card-content>
</ion-card>
